














































































































import { Component, Vue } from 'vue-property-decorator';

import { UserDetail, RoleEnum, ResponseCodeEnum, DataTableRequest, TireStoringContract, TireStoringInfo, EnumObject, TireTypeEnum, Utils, ContractStatusEnum, Location, InputError } from '@/models';
import { tireStoringContractService, tireStoringInfoService, toastService, locationService } from '@/services';
import { SearchContractDataTableSetting, FieldEnum, ActionEnum } from '@/components/shared';

import DataTable from '@/components/shared/table/DataTable.vue';
import QrcodeReader from '@/components/shared/qrcode/QrcodeReader.vue';
import LocationQrcodeReader from '@/components/shared/qrcode/LocationQrcodeReader.vue';


@Component({
  components: {
    DataTable,
    QrcodeReader,
    LocationQrcodeReader,
  },
})
export default class WarehouseDeliveryPage extends Vue {

  private GO_BACK_URL: string = '/home';
  private isImport: boolean = true;
  private showSwitchModeModal: boolean = false;
  private showRemovePickupContractModal: boolean = false;
  private showRemoveDeliveryContractModal: boolean = false;
  private showQrcodeReader: boolean = false;
  private searchText: string = '';
  // private searchResult: TireStoringContract | null = null;
  private selectedId?: string;
  private selectedContract?: TireStoringContract;
  private pickupTableFields = [
    {
      key: 'pickupDate',
      label: 'view.warehouse_delivery.label.pickup_date',
      type: FieldEnum.FIELD_DATE,
      sortable: true,
    },
    {
      key: 'agency.name',
      label: 'view.warehouse_delivery.label.agency_name',
      type: FieldEnum.FIELD_TEXT,
      sortable: true,
    },
    {
      key: 'slipNo',
      label: 'view.warehouse_delivery.label.contract_number',
      type: FieldEnum.FIELD_TEXT,
      sortable: true,
    },
    {
      key: 'number',
      label: 'view.warehouse_delivery.label.tire_number',
      type: FieldEnum.FIELD_CUSTOM,
      sortable: false,
      htmlFunction: (item: TireStoringContract) => {
        if (item.tireType === TireTypeEnum.SUMMER) {
          return (item.summerSeasonInfo && item.summerSeasonInfo.tires) ? item.summerSeasonInfo.tires.length : '';
        } else if (item.tireType === TireTypeEnum.WINTER) {
          return (item.winterSeasonInfo && item.winterSeasonInfo.tires) ? item.winterSeasonInfo.tires.length : '';
        } else {
          return '';
        }
      },
    },
    {
      key: 'locationNo',
      label: 'view.search_tire_contract.label.location_no',
      type: FieldEnum.FIELD_CUSTOM_LOCATION_NO,
      sortable: false,
      thClass: 'w-25',
    },
    {
      key: 'id',
      label: 'view.warehouse_delivery.label.remove_contract',
      type: FieldEnum.FIELD_BUTTON,
      sortable: false,
      buttons: [
        {
          'key': 'pickupDate',
          'type': ActionEnum.ACTION_CUSTOM,
          'text': 'view.warehouse_delivery.label.remove_contract',
          'method': (item: TireStoringContract) => this.openRemovePickupContractModal(item),
        },
      ],
    },

  ];
  private deliveryTableFields = [
    {
      key: 'deliveryDate',
      label: 'view.warehouse_delivery.label.delivary_date',
      type: FieldEnum.FIELD_DATE,
      sortable: true,
    },
    {
      key: 'agency.name',
      label: 'view.warehouse_delivery.label.agency_name',
      type: FieldEnum.FIELD_TEXT,
      sortable: true,
    },
    {
      key: 'slipNo',
      label: 'view.warehouse_delivery.label.contract_number',
      type: FieldEnum.FIELD_TEXT,
      sortable: true,
    },
    {
      key: 'number',
      label: 'view.warehouse_delivery.label.tire_number',
      type: FieldEnum.FIELD_CUSTOM,
      sortable: false,
      htmlFunction: (item: TireStoringContract) => {
        if (item.tireType === TireTypeEnum.SUMMER) {
          return (item.summerSeasonInfo && item.summerSeasonInfo.tires) ? item.summerSeasonInfo.tires.length : '';
        } else if (item.tireType === TireTypeEnum.WINTER) {
          return (item.winterSeasonInfo && item.winterSeasonInfo.tires) ? item.winterSeasonInfo.tires.length : '';
        } else {
          return '';
        }
      },
    },
    {
      key: 'id',
      label: 'view.warehouse_delivery.label.remove_contract',
      type: FieldEnum.FIELD_BUTTON,
      sortable: false,
      buttons: [
        {
          'key': 'pickupDate',
          'type': ActionEnum.ACTION_CUSTOM,
          'text': 'view.warehouse_delivery.label.remove_contract',
          'method': (item: TireStoringContract) => this.openRemoveDeliveryContractModal(item),
        },
      ],
    }
  ];
  private getItems: Function = new Function();
  private tableSetting: SearchContractDataTableSetting = new SearchContractDataTableSetting();
  private pickingUpStatus: number = 3;
  private deliveringStatus: number = 6;
  private requestPickupStatus: number = 2;
  private listTire: TireStoringInfo[] = [];
  private mode: any;
  private isWarehouse: boolean = false;
  private showLocationQrcodeReader: boolean = false;
  private scanLocations: string[] = [];
  private location: Location = new Location(); 
  private user: UserDetail = this.$store.state.user;
  private selectedIds: string[] = [];
  private listContract: TireStoringContract[] = [];

  private created() {
    const user: UserDetail | undefined = this.$store.state.user;

    if (user && user.role === RoleEnum.ROLE_WAREHOUSE) {
      this.isWarehouse = true;
    }
    if (!this.$route.query.mode) {
      this.$router.push(this.GO_BACK_URL);
    }
    if(this.user && !(this.user.role === RoleEnum.ROLE_WAREHOUSE || this.user.role === RoleEnum.ROLE_ADMIN || this.user.role === RoleEnum.ROLE_COMPANY_ADMIN)) {
      const tableFieldLocationNo = this.pickupTableFields.find((item: any) => item.key === 'locationNo');
      if(tableFieldLocationNo) {
        tableFieldLocationNo.type = FieldEnum.FIELD_TEXT;
        tableFieldLocationNo.thClass = '';
      }
    }
    this.mode = this.$route.query.mode;
    const mode: any = this.$route.query.mode;
    if (mode === 'import') {
      this.isImport = true;
    } else if (mode === 'export') {
      this.isImport = false;
    } else {
      this.$router.push(this.GO_BACK_URL);
    }

    this.loadContracts();
  }

  private loadContracts() {
    if (this.isImport) {
      this.getItems = ((request: DataTableRequest) => {
        const errors: InputError[] = [
          { field: 'rackLocation', isError: undefined, message: [] },
          { field: 'columnLocation', isError: undefined, message: [] },
          { field: 'rowLocation', isError: undefined, message: [] },
        ];
        return tireStoringContractService.getByStatus(request, this.pickingUpStatus, false, this.requestPickupStatus)
          .then((res) => {
            if (res.data.items && res.data.totalRows && this.tableSetting) {
              this.tableSetting.totalRows = res.data.totalRows;
              const result = res.data.items;
              this.listContract = res.data.items;
              result.forEach((e: any) => {
                  e['isEdit'] =  false;
                  e['errors'] = errors;
                  e['locationNo'] = (e.rackLocation || "") + " " + (e.columnLocation  || "") + " " + (e.rowLocation || "");
                })
              return res.data.items || [];
            }
          });
      });
      this.tableSetting = SearchContractDataTableSetting.init('pickupDate', 'desc', this.pickupTableFields, this.getItems, false);
      this.tableSetting.isRowClickSelected = true;
      
    } else {
      this.getItems = ((request: DataTableRequest) => {
        return tireStoringContractService.getByStatus(request, this.deliveringStatus, false)
          .then((res) => {
            if (res.data.items && res.data.totalRows && this.tableSetting) {
              this.tableSetting.totalRows = res.data.totalRows;
              this.listContract = res.data.items;
              return res.data.items || [];
            }
          });
      });
      this.tableSetting = SearchContractDataTableSetting.init('deliveryDate', 'desc', this.deliveryTableFields, this.getItems, false);
      this.tableSetting.isRowClickSelected = true;
    }

  }

  private loadTireInfo(tireId: string, status: number, status02: number = 0) {
    const itemIndex = this.listTire.findIndex((tire) => tire.id === tireId);
    if (itemIndex > -1) {
      return;
    }
    tireStoringInfoService.getWithStatus(tireId, status, status02)
      .then((res) => {
        if (res.data.code === ResponseCodeEnum.CODE_SUCCESS && res.data.data) {
          toastService.successMessage('view.warehouse_delivery.label.msg_found_tire');
          this.listTire.push(res.data.data);
          // Select contract in table based on list tire Id
          this.loadSelectedContract(this.listTire);
        }
      });
  }

  private removeTire(tireId: string) {
    const itemIndex = this.listTire.findIndex((tire) => tire.id === tireId);
    if (itemIndex > -1) {
      this.listTire.splice(itemIndex, 1);
      // Select contract in table based on list tire Id
      this.loadSelectedContract(this.listTire);
    }
  }

  private loadSelectedContract(tires: TireStoringInfo[]) {
    if (!tires) {
      return;
    }
    const tireIds: any[] = tires
      .map((tire) => tire.id)
      .filter((id) => id !== undefined);
    tireStoringInfoService.getSelectedContractByIds(tireIds)
      .then((res) => {
        if (res.data.code === ResponseCodeEnum.CODE_SUCCESS && res.data.data) {
          const selectedContractIds: string[] = res.data.data;
          selectedContractIds.forEach((contractId) => toastService.successMessage('view.warehouse_delivery.label.msg_contract_selected'));
          this.selectedIds = selectedContractIds;
          // Select found contract
          (this.$refs.dataTable as any).selectItems(selectedContractIds);
          // Set scanned location
          if(this.location.id) {
            (this.$refs.dataTable as any).setLocation(this.location, selectedContractIds);
          }
          // if( this.selectedIds.length && this.location.id){
          //   this.pickupTableFields.splice(4,0,
          //     {
          //       key: 'locationNo',
          //       label: 'view.search_tire_contract.label.location_no',
          //       type: FieldEnum.FIELD_CUSTOM_LOCATION_NO,
          //       sortable: false,
          //     },
          //   );
          // }
        }
      }).finally(() => {
        this.listTire = [];
      });
  }

  private checkSwitchMode() {
    const selectedContractIds: string[] = this.tableSetting.selected;
    if (selectedContractIds && selectedContractIds.length > 0) {
      this.showSwitchModeModal = true;
    } else {
      this.switchMode();
    }
  }

  private switchMode() {
    this.isImport = !this.isImport;
    this.loadContracts();
    (this.$refs.dataTable as any).refreshTable();
    this.searchText = '';
    this.listTire = [];
    this.$router.push({
      name: 'routes.warehouse.delivery',
      query: { mode: this.isImport ? 'import' : 'export' },
    })
  }

  private scanLocationQrCode() {
    if(this.isImport){
      this.showLocationQrcodeReader = true;
    } else {
      this.showQrcodeReader = true;
    }
  }

  private scanQrCode() {
    this.showQrcodeReader = true;
  }

  private onDecodeLocation(result: string) {
    if(result) {
          const results: string[] = result.split(',');
          if (results) {
            this.scanLocations = results;
          }
        }

        
    locationService.get(this.scanLocations[0]).then((res:any) => {
      if(res.data.code === ResponseCodeEnum.CODE_SUCCESS && res.data.data) {
        this.scanLocations = [];
        this.location = res.data.data;
        this.showLocationQrcodeReader = false;
        this.scanQrCode()

      } else {
        toastService.errorMessage('common.message.tire_location_not_exist');
      }
    })
  }

  private onDecode(result: string) {
    this.showQrcodeReader = false;
    const results: string[] = result.split(',');
    if (results) {
        if (this.isImport) {  
          results.forEach((tire) => this.loadTireInfo(tire, this.pickingUpStatus, this.requestPickupStatus));  
        } else { 
          results.forEach((tire) => this.loadTireInfo(tire, this.deliveringStatus));
        }
    }
  }

  private search() {
    // this.searchResult = null;
    this.tableSetting.filter = '';
    if (this.searchText) {
      tireStoringContractService.getBySlipNo(this.searchText)
        .then((res) => {
          if (res.data.code === ResponseCodeEnum.CODE_SUCCESS && res.data.data) {
            if (this.isImport) {
              // Only show contract with status === 集荷中
              if (res.data.data.status === this.pickingUpStatus || res.data.data.status === this.requestPickupStatus) {
                // this.searchResult = res.data.data;
                // this.tableSetting.filter = this.searchText;
                (this.$refs.dataTable as any).selectItem(res.data.data.id);
                
              } else {
                toastService.errorMessage('view.warehouse_delivery.label.msg_search_wrong_status');
              }
            } else {
               // Only show contract with status === 出荷待ち
              if (res.data.data.status === this.deliveringStatus) {
                // this.searchResult = res.data.data;
                // this.tableSetting.filter = this.searchText;
                (this.$refs.dataTable as any).selectItem(res.data.data.id);
              } else {
                toastService.errorMessage('view.warehouse_delivery.label.msg_search_wrong_status');
              }
            }
          }
        });
    }
  }

  private openRemovePickupContractModal(contract: TireStoringContract | undefined) {
    this.selectedId = contract ? contract.id : '';
    this.selectedContract = contract;
    this.showRemovePickupContractModal = true;
  }

  private openRemoveDeliveryContractModal(contract: TireStoringContract | undefined) {
    this.selectedId = contract ? contract.id : '';
    this.selectedContract = contract;
    this.showRemoveDeliveryContractModal = true;
  }

  private removeContract() {
    if (this.selectedId && this.selectedContract) {
      if (this.isImport) {
        if (this.selectedContract.status === ContractStatusEnum.REQUEST_PICKUP) {
          tireStoringContractService.cancelPickup([this.selectedId])
            .then((res) => {
              if (res.data.code === ResponseCodeEnum.CODE_SUCCESS) {
                toastService.successMessage('view.tire_contract_detail.msg.cancel_pickup_success');
                (this.$refs.dataTable as any).refreshTable();
              }
            });
        } else {
          tireStoringContractService.requestPickup([this.selectedId])
            .then((res) => {
              if (res.data.code === ResponseCodeEnum.CODE_SUCCESS) {
                toastService.successMessage('view.warehouse_delivery.label.msg_remove_success');
                (this.$refs.dataTable as any).refreshTable();
              }
            });
        }
      } else {
        tireStoringContractService.requestDelivery([this.selectedId])
          .then((res) => {
            if (res.data.code === ResponseCodeEnum.CODE_SUCCESS) {
              toastService.successMessage('view.warehouse_delivery.label.msg_remove_success');
              (this.$refs.dataTable as any).refreshTable();
            }
          });
      }
    }
  }

  private importSelectedContract() {
    if (!this.isImport) {
      return;
    }
    const selectedContractIds: string[] = this.tableSetting.selected;
    if (selectedContractIds && selectedContractIds.length > 0) {
      // const listImportContract: TireStoringContract[] = this.listContract.filter(c => c.id && selectedContractIds.includes(c.id)); 
      // Import contract to warehouse
      tireStoringContractService.importToWarehouse(selectedContractIds, this.location.id)
        .then((res) => {
          if (res.data.code === ResponseCodeEnum.CODE_SUCCESS) {
            toastService.successMessage('view.warehouse_delivery.label.msg_imported_success');
            (this.$refs.dataTable as any).refreshTable();
          }
        });
    }
  }

  private exportDeliveryCsv() {
    tireStoringContractService.exportCsv(new DataTableRequest({
      currentPage: this.tableSetting.currentPage,
      perPage: this.tableSetting.totalRows,
      sortBy: this.tableSetting.sortBy,
      sortDesc: this.tableSetting.sortDesc,
      filter: this.tableSetting.filter
    }), this.deliveringStatus, this.mode);
  }

  private exportPickingUpCsv() {
    tireStoringContractService.exportCsv(new DataTableRequest({
      currentPage: this.tableSetting.currentPage,
      perPage: this.tableSetting.totalRows,
      sortBy: this.tableSetting.sortBy,
      sortDesc: this.tableSetting.sortDesc,
      filter: this.tableSetting.filter
    }), this.pickingUpStatus, this.mode);
  }

  private exportSelectedContract() {
    if (this.isImport) {
      return;
    }
    const selectedContractIds: string[] = this.tableSetting.selected;
    if (selectedContractIds && selectedContractIds.length > 0) {
      // Export contract from warehouse
      tireStoringContractService.exportFromWarehouse(selectedContractIds)
        .then((res) => {
          if (res.data.code === ResponseCodeEnum.CODE_SUCCESS) {
            toastService.successMessage('view.warehouse_delivery.label.msg_exported_success');
            (this.$refs.dataTable as any).refreshTable();
          }
        });
    }
  }

  private handleReturnLocationQR(isClose: boolean) {
    if(isClose) {
      this.showLocationQrcodeReader = false;     
    }
  }
  private handleReturnTireQR(isClose: boolean) {
    if(isClose) {
      this.showQrcodeReader = false;
      if(this.isImport) {
        this.showLocationQrcodeReader = true;
      }
    }
  }
  private skipScanLocation() {
    this.scanLocations = [];
    this.location = new Location;
    this.showLocationQrcodeReader = false;     
    this.showQrcodeReader = true;
  }

  private updateLocationNo(tireContract: any, dataTable: any) {
    const errors: InputError[] = [
      { field: 'rackLocation', isError: undefined, message: [] },
      { field: 'columnLocation', isError: undefined, message: [] },
      { field: 'rowLocation', isError: undefined, message: [] },
    ];
    locationService.checkExist({
      shelf1: tireContract.rackLocation,
      shelf2: tireContract.columnLocation,
      shelf3: tireContract.rowLocation
    } as Location
    ).then((res) =>{
      if(res.data.data){
        tireStoringContractService
        .updateLocationNo(tireContract)
        .then((res) => {
          if(res.data.code === ResponseCodeEnum.CODE_SUCCESS && res.data.data) {
            toastService.success(this.$t('view.tire_register.message.contract_updated').toString() + res.data.data.slipNo);
            const item =  dataTable.find((e: any) => e.id === tireContract.id);
            item['isEdit'] = false;
          }
        })
        .catch((error) => {
          if (error.response.status === 400) {
            error.response.data.errors.forEach((err: any) => {
              const inputError = errors.find((e) => e.field === err.field);          
              if (inputError !== undefined) {
                if (inputError.isError === undefined) {
                  inputError.isError = false;
                  inputError.message = [];
                }
                inputError.message.push(err.defaultMessage);
              }
            });
            dataTable.forEach((e: any) => {
              if(e.id === tireContract.id) {
                e.errors = errors;
              }
            })
          }
        });
      }else {
        toastService.errorMessage('common.message.tire_location_not_exist');
      }
    })
  }

}
